/**
 * The locations someone opened settings for most recently, per person and
 * account, so the switcher can offer them first on accounts with hundreds of
 * locations. Browser storage only; it may be unavailable, so every access is
 * guarded and the switcher works without it.
 */
export interface RecentLocation {
  id: string;
  name: string;
}

const MAX = 5;
const key = (userId: string, accountId: string) => `tc-settings-recent-locations:${userId}:${accountId}`;

export function readRecentLocations(userId: string, accountId: string): RecentLocation[] {
  try {
    const raw = window.localStorage.getItem(key(userId, accountId));
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((l) => l && typeof l.id === 'string' && typeof l.name === 'string').slice(0, MAX) : [];
  } catch {
    return [];
  }
}

/** Puts `location` first, keeping at most five, without duplicates. */
export function rememberRecentLocation(userId: string, accountId: string, location: RecentLocation): RecentLocation[] {
  const next = [location, ...readRecentLocations(userId, accountId).filter((l) => l.id !== location.id)].slice(0, MAX);
  try {
    window.localStorage.setItem(key(userId, accountId), JSON.stringify(next));
  } catch {
    /* storage unavailable: recents are a convenience */
  }
  return next;
}
